// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1734":"1819b2526b32aeb8","2126":"8114d9c5ae753a2b","8241":"b37c0495baadef78"}[chunkId] + ".js";
};